import { Box, Typography, useTheme } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { Accordion } from 'components';

export const RiskDisclosure = () => {
  const theme = useTheme();
  return (
    <Box
      style={{
        marginTop: '20px',
      }}
    >
      <Accordion
        type="solid"
        bgColor={theme.palette.grey[100]}
        icon={<ExpandMoreIcon />}
        iconPosition="right"
        titleComponent={
          <Typography variant="h3" style={{ marginBottom: 0, marginRight: 10, fontWeight: 600, flex: 1 }}>
            Disclosure
          </Typography>
        }
        testid="risk-data"
      >
        <Box style={{ padding: 20 }}>
          <Box style={{ marginBottom: 10 }}>
            Ardonagh Specialty acts as cover holder with authority to provide quotes on behalf of a pre-determined panel of Insurers based
            on the parameters/rules agreed as part of our binding authority agreements and with specific reference to the classes and, where
            relevant, ISOs (standardised Insurance Office Forms) permitted.
          </Box>
          <Box style={{ marginBottom: 10 }}>
            The source of quotes displayed within Vantage is limited to quotes provided by the relevant panel of Insurers and not from a
            wider selection of capacity providers on a whole of market basis. If you want a wider selection of quotes, then you should ask
            us to refer the risk. We may communicate any quotes obtained through a referral of risk but they may not be available for
            binding within Vantage. [Note: we understand that there is a process by which a broker can communicate a wish to receive a wider
            set of quotes outside Vantage].
          </Box>
          <Box style={{ marginBottom: 10 }}>
            The provision of and acceptance of quotes is subject to our applicable Vantage Client Terms of Use and TOBA.
          </Box>
          <Box style={{ marginBottom: 10 }}>
            Quotes provided for the risks you are seeking to place will not be presented in any particular order and we will not rank them.
            We do not provide you with any advice on selecting the best or most suitable of the quotes presented to you within Vantage.
          </Box>
        </Box>
      </Accordion>
    </Box>
  );
};
